import { render, staticRenderFns } from "./menuDistributDialog.vue?vue&type=template&id=497d50b9&"
import script from "./menuDistributDialog.vue?vue&type=script&lang=js&"
export * from "./menuDistributDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports